var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data-box"},[_c('div',{staticClass:"no-data-content"},[_c('img',{attrs:{"draggable":"false","src":_vm.noData,"alt":""}}),_c('span',{staticClass:"no-data-text"},[_vm._v(_vm._s(_vm.translateTitle(_vm.text)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }